module.exports = __webpack_public_path__ + "static/media/search-sections.2585b1b7.jpeg";